module.exports = __webpack_public_path__ + "media/images/top/rank-silver-45436b3681572c6ed1f97be00624685f.webp";